// extracted by mini-css-extract-plugin
export default {"tableSection":"TotalAdmin_tableSection__f3ish"};